new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {

    const copyButton = document.getElementById('copy-button');
    const cupomValue = document.getElementById('cupom-value');

    if (copyButton && cupomValue) {
        copyButton.addEventListener('click', async () => {
            try {
                const cupomText = cupomValue.textContent.trim();
                
                // Copia o texto para a área de transferência
                await navigator.clipboard.writeText(cupomText);
                
                // Salva o texto original do botão
                const originalText = copyButton.textContent;
                
                // Altera o texto do botão para mostrar que foi copiado
                copyButton.textContent = 'COPIADO!';
                copyButton.style.backgroundColor = '#28a745';
                copyButton.style.borderColor = '#28a745';
                
                // Restaura o texto original após 2 segundos
                setTimeout(() => {
                    copyButton.textContent = originalText;
                    copyButton.style.backgroundColor = '';
                    copyButton.style.borderColor = '';
                }, 2000);
                
            } catch (err) {
                // Fallback para navegadores que não suportam clipboard API
                const textArea = document.createElement('textarea');
                textArea.value = cupomValue.textContent.trim();
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // Salva o texto original do botão
                const originalText = copyButton.textContent;
                
                // Altera o texto do botão para mostrar que foi copiado
                copyButton.textContent = 'COPIADO!';
                copyButton.style.backgroundColor = '#28a745';
                copyButton.style.borderColor = '#28a745';
                
                // Restaura o texto original após 2 segundos
                setTimeout(() => {
                    copyButton.textContent = originalText;
                    copyButton.style.backgroundColor = '';
                    copyButton.style.borderColor = '';
                }, 2000);
            }
        });
    }

    const stopwatchElement = document.querySelector('.stopwatch');
    if (stopwatchElement) {
      const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
      const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
      const dia = parseInt(stopwatchElement.getAttribute('data-day'));
      const mes = parseInt(stopwatchElement.getAttribute('data-month'));
      const ano = parseInt(stopwatchElement.getAttribute('data-year'));
  
      // Verifique se os atributos necessários estão definidos e não são NaN
      if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
        const urlAtual = window.location.pathname;
        let dataTermino;
        let cronometro;
  
        function atualizarCronometro() {
          const agora = new Date().getTime();
          const termino = dataTermino.getTime();
          const tempoRestante = termino - agora;
  
          if (tempoRestante >= 0) {
            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);
  
            function formatarDigitos(numero) {
                // Formata o número com dois dígitos (exemplo: "08", "12")
                const numeroFormatado = numero.toString().padStart(2, '0');
                
                // Divide os dígitos e envolve cada um em uma tag <span>
                return `<span>${numeroFormatado[0]}</span><span>${numeroFormatado[1]}</span>`;
            }
  
            const diasFormatado = formatarDigitos(dias);
            const horasFormatado = formatarDigitos(horas);
            const minutosFormatado = formatarDigitos(minutos);
            const segundosFormatado = formatarDigitos(segundos);
  
            document.getElementById("cronometro").innerHTML =`<p>Acaba em</p> <div>${diasFormatado}d ${horasFormatado}h ${minutosFormatado}m ${segundosFormatado}s</div><p>ou enquanto durarem os estoques</p>`;
          } else {
            document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
            clearInterval(cronometro);
          }
        }
  
        function mostrarCronometro() {
          dataTermino = new Date(ano, mes - 1, dia, hora, 0);
          cronometro = setInterval(atualizarCronometro, 1000);
        }
  
        // Mostrar cronômetro em todas as páginas se urlParametro estiver vazio
        if (urlParametro === "" || urlAtual.includes(urlParametro)) {
          mostrarCronometro();
        } else {
          stopwatchElement.style.display = 'none';
        }
      } else {
        console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
      }
    } else {
      console.error('Elemento .stopwatch não encontrado.');
    }
    
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.faixa-comunicado').then(element => {
        const widgetCategory = element.querySelector('#faixa-comunicado');
        if(widgetCategory) {
            $('#faixa-comunicado').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('#carrousel-product-ratings').then(element => {
        $('#carrousel-product-ratings').slick({
            dots: true,
            appendArrows: $('.product-ratings .append-arrow'),
            arrows: true,
            autoplay: true,
            infinite: true,
            mobileFirst: true,
            speed: 1000,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    });

    // waitForElementToExist('#js-carrousel-instagram').then(element => {
    //     if (window.matchMedia("(min-width: 991px)").matches) {
    //         // Banner Instagram 
    //        $('#js-carrousel-instagram').slick({
    //            arrows: false,
    //            dots: false,
    //            infinite: true,
    //            autoplay: false,
    //            speed: 1000,
    //            slidesToShow: 2,
    //            slidesToScroll: 2,
    //        });
    //    }else{
    //         $('#js-carrousel-instagram').slick({
    //             arrows: false,
    //             dots: false,
    //             infinite: true,
    //             autoplay: true,
    //             speed: 1000,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //         });
    //    }
    // });


    waitForElementToExist('.faixa-cupom').then(element => {
        const faixaCupom = element;
        if (faixaCupom) {
            const form = document.querySelector('.faixa-cupom-form');
            const spanCupom = form ? form.querySelector('#valorParaCopiar') : null;
            const botaoCopiar = form ? form.querySelector('button') : null;

            function alterarTextoBotao(botao, textoOriginal, textoNovo, duracao = 2000) {
                const textoAtual = botao.textContent || botao.innerText;
                botao.textContent = textoNovo;
                setTimeout(() => {
                    botao.textContent = textoOriginal;
                }, duracao);
            }

            async function copiarTexto(texto, botao) {
                const textoOriginal = botao.textContent || botao.innerText;
                try {
                    await navigator.clipboard.writeText(texto);
                    alterarTextoBotao(botao, textoOriginal, 'Copiado!');
                } catch (err) {
                    const textArea = document.createElement('textarea');
                    textArea.value = texto;
                    textArea.setAttribute('readonly', '');
                    textArea.style.position = 'absolute';
                    textArea.style.left = '-9999px';
                    document.body.appendChild(textArea);
                    textArea.select();
                    try { document.execCommand('copy'); } catch (e) {}
                    document.body.removeChild(textArea);
                    alterarTextoBotao(botao, textoOriginal, 'Copiado!');
                }
            }

            if (botaoCopiar && spanCupom) {
                botaoCopiar.addEventListener('click', (e) => {
                    e.preventDefault();
                    const textoCupom = (spanCupom.textContent || spanCupom.innerText || '').trim();
                    if (!textoCupom) return;
                    copiarTexto(textoCupom, botaoCopiar);
                });
            }
        }
    });


    waitForElementToExist('.slick-category').then(element => {
        const widgetCategory = element.querySelector('#widget-category');
        if(widgetCategory) {
            $('#widget-category').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            dots: false,
                            slidesToShow: 6,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.lateral-banners').then(element => {
        const widgetCategory = element.querySelector('#lateral-banners');
        if(widgetCategory) {
            $('#lateral-banners').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                speed: 700,
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-2');
        if(firstCarrousel) {
            $('#product_list-2').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    $('.product-ratings-list').slick({
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    });

     waitForElementToExist('.banner-colecoes__list').then(element => {
        $('.banner-colecoes__list').slick({
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-3');
        if(firstCarrousel) {
            $('#product_list-3').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.quarter-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-4');
        if(firstCarrousel) {
            $('#product_list-4').slick({
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });
})

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
        clipboardElement.textContent = "COPIADO!";
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
document.getElementById("tc-coupon")?.addEventListener("click", copyElementContentToClipboard);